module.exports = __webpack_public_path__ + "img/menu_icon02.7e123f9b.png";